<div class="editable-mode-section">
  <mat-button-toggle-group
    [value]="getEditableMode()"
    (change)="onEditableModeChange($event)"
    [hideSingleSelectionIndicator]="true">
    <mat-button-toggle value="not-editable">
      <mat-icon fontSet="material-icons-outlined">edit_off</mat-icon>
      Not Editable
    </mat-button-toggle>
    <mat-button-toggle value="editable">
      <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
      Editable
    </mat-button-toggle>
    <mat-button-toggle value="edit-required">
      <mat-icon fontSet="material-icons-outlined">error_outline</mat-icon>
      Edit Required
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
